import { render, staticRenderFns } from "./Snippet.vue?vue&type=template&id=74b9f6aa&"
import script from "./Snippet.vue?vue&type=script&lang=js&"
export * from "./Snippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports